import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { AsyncPipe, NgIf } from '@angular/common';
import {
    ChangeDetectionStrategy, Component, Input, OnChanges,
    SimpleChanges, ViewEncapsulation,
} from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseLoadingService } from '@fuse/services/loading';

@Component({
    selector          : 'fuse-loading-bar',
    templateUrl       : './loading-bar.component.html',
    styleUrls         : ['./loading-bar.component.scss'],
    encapsulation     : ViewEncapsulation.None,
    changeDetection   : ChangeDetectionStrategy.OnPush,
    exportAs          : 'fuseLoadingBar',
    standalone        : true,
    imports           : [NgIf, AsyncPipe, MatProgressBarModule],
})
export class FuseLoadingBarComponent implements OnChanges
{
    @Input() autoMode: boolean = true;

    /** Expose streams directly — template binds via async pipe to avoid NG0100. */
    readonly show$     = this._fuseLoadingService.show$;
    readonly mode$     = this._fuseLoadingService.mode$;
    readonly progress$ = this._fuseLoadingService.progress$;

    constructor(private _fuseLoadingService: FuseLoadingService) {}

    ngOnChanges(changes: SimpleChanges): void
    {
        if ( 'autoMode' in changes )
        {
            this._fuseLoadingService.setAutoMode(coerceBooleanProperty(changes.autoMode.currentValue));
        }
    }
}
